import router from '@/router';
import { PERMISSION_DENIED } from '@/utils/constants/constants';
import axios from 'axios';

export function setup_axios_interceptors() { //Check's for permission denied error and redirects to login page
  axios.interceptors.response.use(
    response => response,
    error => {
      if (error.response?.data?.code === PERMISSION_DENIED ||
          error.response?.data === PERMISSION_DENIED) {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('otp_verified');
        sessionStorage.setItem('auth_redirect_reason', 'Permission denied. Please login again.');
        router.push({ name: 'UserLogin' });
      }
      return Promise.reject(error);
    }
  );
}